export default __webpack_public_path__ + "resources/icons/n320-ff44.png";